import { createI18n, type Lang } from "@ecliptica/i18n";
import en from "./en.json";
import pt from "./pt.json";

/**
 * No site a língua vem SEMPRE do endereço (sem prefixo = língua por omissão, hoje EN): a pré-renderização e o browser concordam.
 * Os recursos PT continuam carregados e mantidos; só se usam se o PT voltar a ACTIVE_LANGS.
 */
export function createSiteI18n(lng: Lang) {
  return createI18n({ pt, en }, { lng });
}
